import React from 'react';
import PropTypes from 'prop-types';

import guid from '@/shared/utils/guid';
import UserSearch from './UserSearch';

const RelationUserSearch = ({ value, onChange, ...rest }) => (
  <UserSearch
    onChange={user => onChange(user ? user.id : null)}
    value={value}
    withUnassigned
    unassignedId={guid.empty}
    withCurrentUser
    {...rest}
  />
);

RelationUserSearch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  withUnassigned: PropTypes.bool,
  withCurrentUser: PropTypes.bool,
};
RelationUserSearch.defaultProps = {
  value: null,
  withUnassigned: true,
  withCurrentUser: true,
};

export default RelationUserSearch;
